<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
      <i :class="classIcon"></i> {{ name }}
    </div>
    <ul class="nav-dropdown-items" style="background-color: var(--secondary)">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    classIcon() {
      return ["nav-icon", this.icon];
    },
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
  },
};
</script>

<style scoped lang="css">
.nav-link {
  cursor: pointer;
}
.sidebar .nav-link {
  color: #fff;
  font-size: 14px;
}

.sidebar .nav-link:hover {
  color: #fff;
  text-decoration: none;
  background: none;
}

.sidebar .nav-link .nav-icon {
  color: #fff;
}

.sidebar .nav-link .nav-icon:hover {
  color: #fff;
}

.sidebar-minimized .sidebar {
  background: white !important;
}

@media (min-width: 992px) {
  .sidebar-minimized .sidebar .nav-link:hover {
    color: black;
    background: white !important;
  }
}
.sidebar .nav-dropdown-toggle::before {
  height: 23px;
  margin-top: -12px;
  background-image: url("../../../public/img/png/icon-left.png");
}
.sidebar .nav-link:hover.nav-dropdown-toggle::before {
  background-image: url("../../../public/img/png/icon-left.png");
}
</style>
